import { StatsFileDto } from "@domain";
import { IDtoCommandResults } from "@kernel/ddd";
import {
  BaseHttpService,
  HttpError,
  HttpRequest
} from "@kernel/frontend-react-app";

export class StatsRepositoryService extends BaseHttpService {
  constructor() {
    const fetch = HttpRequest.create("/api/stats");
    super(fetch);
  }

  public async getFile(name: string): Promise<StatsFileDto> {
    const result = (await this.get(`${name}`)) as IDtoCommandResults;
    if (!result.success && result.error) throw new HttpError(result.error);
    return result.item as StatsFileDto;
  }
}
